import React from 'react';
import { List } from '@cdm/quickenloans-library/lib';
import { attributesToProps, domToReact } from 'html-react-parser';
import { renderToString } from 'react-dom/server';
import Identifier from './Identifier/Identifier';
import { mapListType, testAttributes } from './Constants';
import { parserPropTypes, parserPropTypesDefaults } from '../Constants';

const toList = (parserData) =>
{
    const { parserOptions: { replaceFn } } = parserData;
    const Wrapper = ({ 
        name = parserPropTypesDefaults.name, 
        type = parserPropTypesDefaults.type, 
        attribs = parserPropTypesDefaults.attribs,
        children = parserPropTypesDefaults.children
    }) =>
    {
        if (type !== 'tag') return null;
        if (!name || !['ul', 'ol'].includes(name)) return null;
        if (!children || !Array.isArray(children)) return null;

        const props = attributesToProps( attribs );
        const id = renderToString(<Identifier />);
        const listItems = children.map((child, ix) => 
        {
            if ( child.name === 'li' )
            {
                const key = `parsed-li-${ix}${id}`;
                return React.createElement(
                    'li',
                    {
                        ...attributesToProps(child.attribs),
                        key
                    },
                    domToReact(child.children, replaceFn() )
                )
            }
            return domToReact([child], replaceFn() )
        });

        return (
            <div data-testid={testAttributes.LIST_CONTAINER}>
                <List as={mapListType[name]} {...props}>{listItems}</List>
            </div>
        );
    }
    Wrapper.propTypes = parserPropTypes;
    return Wrapper;
}

export default toList;
